
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.656 3.031c1.108 0 2.222.41 3.063 1.25 1.681 1.681 1.681 4.444 0 6.125l-2.813 2.781 1 1-1.406 1.406-1-1-9.5 9.5c-1.064 1.064-1.845 1.684-2.531 2.063s-1.277.493-1.688.563-.636.113-1.063.344-1.04.696-2 1.656l-.719.688-.719-.688-2-2L2.592 26l.688-.719c.986-.986 1.475-1.621 1.719-2.063s.276-.66.344-1.063.196-1.011.563-1.688.96-1.429 2-2.469l9.5-9.5-1-1 1.406-1.406 1 1 2.781-2.813a4.313 4.313 0 013.063-1.25zm0 2A2.34 2.34 0 0023 5.719L20.219 8.5l3.281 3.281L26.281 9a2.297 2.297 0 000-3.281 2.273 2.273 0 00-1.625-.688zm-5.843 4.875l-9.5 9.5c-.96.96-1.426 1.605-1.656 2.031s-.274.621-.344 1.031-.184 1.033-.563 1.719c-.259.469-.859 1.1-1.406 1.719l.75.75c.601-.529 1.227-1.126 1.688-1.375.677-.366 1.254-.463 1.656-.531s.621-.1 1.063-.344 1.108-.733 2.094-1.719l9.5-9.5z"}})])
          )
        }
      }
    